// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__IEkli","Logo":"Login_Logo__1hRi9","Form":"Login_Form__20hI-","Input":"Login_Input__1NLMH","Error":"Login_Error__JLWwo","Loading":"Login_Loading__2x1ie"};